import React, { useCallback, useEffect } from 'react'
import {UserGroupIcon,CollectionIcon, LightBulbIcon, ChartSquareBarIcon} from "@heroicons/react/outline";
import DashboardCard from './DashboardCard';
import DashboardCardShimmer from './DashboardCardShimmer';
import { useRecoilState, useRecoilValue } from 'recoil';
import { dashboardLoading, dashboardData } from '../../recoil/dashboard';
import { authenticated } from '../../recoil/auth';
import axios from 'axios';
import { domainWeb } from '../../config/constants';

const DashboardGridCards = () => {
  const [loading, setLoading] = useRecoilState(dashboardLoading);
  const [data, setData] = useRecoilState(dashboardData);
  const auth = useRecoilValue(authenticated);

  const getDashboardData = useCallback( async () => {
    setLoading(true);
    try {
      let response = await axios.get(`${domainWeb}/admin/dashboard`, 
          {headers: {
              'Content-Type': 'application/json', 
              'Accept': 'application/json', 
              'Authorization': 'Bearer ' + auth.token
          }},
      );
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }, [auth.token, setLoading, setData])

  useEffect(() => {
    getDashboardData();
  }, [getDashboardData]);

  if (loading || data['average_score'] === undefined) {
    return (
      <div className="grid grid-cols-4 gap-12 mb-6">
        <DashboardCardShimmer />
        <DashboardCardShimmer />
        <DashboardCardShimmer />
        <DashboardCardShimmer />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-4 gap-12 mb-6">
      <DashboardCard color="bg-pink-500" icon={UserGroupIcon} label="Jumlah Pengguna" value={data['count_users']} />
      <DashboardCard color="bg-pink-500" icon={CollectionIcon} label="Jumlah Konten" value={data['count_contents']} />
      <DashboardCard color="bg-sky-500" icon={LightBulbIcon} label="Jumlah Soal Kuis" value={data['count_quizzes']} />
      <DashboardCard color="bg-green-500" icon={ChartSquareBarIcon} label="Rata-rata Nilai Kuis" value={data['average_score'].toFixed(1)} />
    </div>
  );
  
}

export default DashboardGridCards